// copied from https://github.com/tamino-martinius/node-ts-dedent
export var dedent = function (templ) {
    var values = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        values[_i - 1] = arguments[_i];
    }
    var strings = Array.from(typeof templ === 'string' ? [templ] : templ);
    // 1. Remove trailing whitespace.
    strings[strings.length - 1] = strings[strings.length - 1].replace(/\r?\n([\t ]*)$/, '');
    // 2. Find all line breaks to determine the highest common indentation level.
    var indentLengths = strings.reduce(function (arr, str) {
        var matches = str.match(/\n([\t ]+|(?!\s).)/g);
        if (matches) {
            return arr.concat(matches.map(function (match) { var _a, _b; return (_b = (_a = match.match(/[\t ]/g)) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0; }));
        }
        return arr;
    }, []);
    // 3. Remove the common indentation from all strings.
    if (indentLengths.length) {
        var pattern_1 = new RegExp("\n[\t ]{".concat(Math.min.apply(Math, indentLengths), "}"), 'g');
        strings = strings.map(function (str) { return str.replace(pattern_1, '\n'); });
    }
    // 4. Remove leading whitespace.
    strings[0] = strings[0].replace(/^\r?\n/, '');
    // 5. Perform interpolation.
    var string = strings[0];
    values.forEach(function (value, i) {
        // 5.1 Read current indentation level
        var endentations = string.match(/(?:^|\n)( *)$/);
        var endentation = endentations ? endentations[1] : '';
        var indentedValue = value;
        // 5.2 Add indentation to values with multiline strings
        if (typeof value === 'string' && value.includes('\n')) {
            indentedValue = String(value)
                .split('\n')
                .map(function (str, i) {
                return i === 0 ? str : "".concat(endentation).concat(str);
            })
                .join('\n');
        }
        string += "".concat(indentedValue).concat(strings[i + 1]);
    });
    return string;
};
//# sourceMappingURL=dedent.js.map